import { wsClient } from 'api/WsClient';

export const WebSocketPlugin = {
  install(Vue) {
    Vue.prototype.$ws = wsClient;
  },
};
